module.exports = __webpack_public_path__ + "img/logo@2x.9e9b76db.png";